// Define module using Universal Module Definition pattern
// https://github.com/umdjs/umd/blob/master/returnExports.js

(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // Support AMD. Register as an anonymous module.
    // EDIT: List all dependencies in AMD style
    define(['angular', 'dropzone'], factory);
  }
  else {
    // No AMD. Set module as a global variable
    // EDIT: Pass dependencies to factory function
    factory(root.angular, root.Dropzone);
  }
}(this,
//EDIT: The dependencies are passed to this function
function (angular, Dropzone) {
  //---------------------------------------------------
  // BEGIN code for this module
  //---------------------------------------------------

  'use strict';

  return angular.module('ngDropzone', [])
    .directive('ngDropzone', function ($timeout) {
      return {
        restrict: 'AE',
        template: '<div ng-transclude></div>',
        transclude: true,
        scope: {
          dropzone: '=',
          dropzoneConfig: '=',
          eventHandlers: '='
        },
        link: function(scope, element, attrs, ctrls) {
          try { Dropzone }
          catch (error) {
            throw new Error('Dropzone.js not loaded.');
          }

var dropzone;
$timeout(function () {
          dropzone = new Dropzone(element[0], scope.dropzoneConfig);
	
}, 0);

          if (scope.eventHandlers) {
            Object.keys(scope.eventHandlers).forEach(function (eventName) {
              dropzone.on(eventName, scope.eventHandlers[eventName]);
            });
          }

          scope.dropzone = dropzone;
        }
      };
    });

  //---------------------------------------------------
  // END code for this module
  //---------------------------------------------------
}));



angular.module('bmsApp.directives')
	.directive('dropzone', function ($timeout) {
		return {
			restrict: 'A',
			link: function (scope, element, attrs) {

				var config;
				var instance;

                scope.$watch(attrs.dropzoneConfig, function (newValue) {
                    if (angular.isObject(newValue)) {
                        config = newValue;
                        instance = new Dropzone(element[0], config);
                        // bind the given event handlers
                        angular.forEach(config.eventHandlers, function (handler, event) {
                            instance.on(event, handler);
                        });
                    }
                }, true);

//				config = scope.$eval(attrs.dropzoneConfig);
//				if (angular.isUndefined(config)) {
//					return;
//				}
//
//				$timeout(function () {
//					instance = new Dropzone(element[0], config);
//
////					if (!angular.isUndefined(scope.events)) {
////						angular.forEach(scope.events, function (handler, event) {
////							instance.on(event, handler);
////						});
////					}
//
//					// bind the given event handlers
//					angular.forEach(config.eventHandlers, function (handler, event) {
//						instance.on(event, handler);
//					});
//
//				}, 0);

//				scope.$watch(function () {
//					return ngModel.$modelValue;
//				}, function (newValue, oldValue) {
//					if (!angular.isUndefined(instance) && !angular.isUndefined(newValue)) {
//						element.timeEntry('setTime', newValue);
//					}
//				});

			},
		};
	});
